import Layout from "@/views/layout/index";

const supplychainNew = [
  {
    path: "/supplychain",
    name: "supplychain",
    isChildren: false,
    hidden: true,
    component: Layout,
    mCode:"YYZX",
    meta: {title: '应用中心', icon: 'industryCenter'},
    children: [
        {
            path: '/supplychain',
            component: () => import('@/views/supplychain/index'),
        }
    ]
  },
]

export default supplychainNew



// WEBPACK FOOTER //
// ./src/router/supplyChainNew/index.js